import { IMessage } from '@eventr/common'
import { ColoursObj, drawerStore } from '@eventr/common-storybook'
import { Box, Divider } from '@mui/material'
import { Emoji } from 'emoji-picker-react'
import { FC } from 'react'
import { getEmojiUnifiedFromRocketName } from '../../emoji/emojiFuncs'
import { useRocketChatContext } from '../../rocketChatProvider'
import { rocketApiSignal } from '../chatProvider'
import { emojiPickerState } from './messageActionSheetBody'

interface IRocketReactionRowProps {
    message: IMessage
}

type TReactionItem = {
    rocketKey: string
    unified: string
}

export const RocketReactionRow: FC<IRocketReactionRowProps> = ({ message }) => {
    const { rcUserInfo } = useRocketChatContext()
    const reactions = message.reactions

    let reactionList: TReactionItem[] = [
        {
            rocketKey: ':smile:',
            unified: '1f604',
        },
        {
            rocketKey: ':thumbsup:',
            unified: '1f44d',
        },
        {
            rocketKey: ':thumbsdown:',
            unified: '1f44e',
        },
        {
            rocketKey: ':heart:',
            unified: '2764-fe0f',
        },
        {
            rocketKey: ':clap:',
            unified: '1f44f',
        },
        {
            rocketKey: ':sweat_smile:',
            unified: '1f605',
        },
    ]

    reactions &&
        Object.keys(reactions).forEach((reactionKey) => {
            if (
                ![
                    ':smile:',
                    ':thumbsup:',
                    ':thumbsdown:',
                    ':heart:',
                    ':clap:',
                    ':sweat_smile:',
                ].includes(reactionKey) /// Dont dupe the defaults
            )
                reactionList.unshift({
                    rocketKey: reactionKey,
                    unified: getEmojiUnifiedFromRocketName(reactionKey),
                })
        })

    return (
        <Box>
            <Box
                sx={{
                    display: 'grid',
                    gridAutoFlow: 'column',
                    padding: '8px 0',
                }}
            >
                {reactionList.map((reactionItem: TReactionItem, index) => {
                    if (index > 5) {
                        return null
                    }

                    const hasUserReacted = () => {
                        if (
                            reactions &&
                            reactions[reactionItem.rocketKey] &&
                            reactions[reactionItem.rocketKey].usernames &&
                            reactions[
                                reactionItem.rocketKey
                            ].usernames.includes(rcUserInfo.username)
                        ) {
                            return true
                        }
                        return false
                    }

                    return (
                        <Box
                            width={'100%'}
                            display={'grid'}
                            justifyItems={'center'}
                            key={reactionItem.rocketKey}
                        >
                            <Box
                                onPointerUp={() => {
                                    rocketApiSignal.value.reactToMessage(
                                        reactionItem.rocketKey,
                                        message._id
                                    )
                                    drawerStore().closeDrawer()
                                }}
                                style={{
                                    display: 'grid',
                                    alignItems: 'center',
                                    justifyItems: 'center',
                                    border: hasUserReacted()
                                        ? '1px solid ' +
                                          ColoursObj.core.secondary
                                        : '1px solid transparent',
                                    width: '44px',
                                    height: '42px',
                                    borderRadius: '8px',
                                    gridTemplateColumns: 'auto',
                                }}
                            >
                                <Emoji
                                    unified={reactionItem.unified}
                                    size={24}
                                />
                            </Box>
                        </Box>
                    )
                })}
                <Box width={'100%'} display={'grid'} justifyItems={'center'}>
                    <Box
                        onClick={() => {
                            emojiPickerState.value = true
                        }}
                        style={{
                            display: 'grid',
                            alignItems: 'center',
                            justifyItems: 'center',
                            border: '1px solid transparent',
                            width: '44px',
                            height: '44px',
                            borderRadius: '8px',
                        }}
                    >
                        <Emoji unified="2795" size={24} />
                    </Box>
                </Box>
            </Box>
            <Divider />
        </Box>
    )
}
